import { useTranslation } from 'react-i18next';
import ReactModal from 'react-modal';

type QrConfirmModalProps = {
  onClick: () => void;
  isOpen: boolean;
  onClose: () => void;
};

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: 0,
    border: 0,
  },
};

export default function QrConfirmModal({
  onClick,
  isOpen,
  onClose,
}: QrConfirmModalProps) {
  const { t } = useTranslation();
  return (
    <ReactModal isOpen={isOpen} style={customStyles} onRequestClose={onClose}>
      <div id={'popup-wrap'}>
        <div className={'popup-wrap device-modal'} id={'etc-modal'}>
          <div className={'popup-cont'}>
            <center>
              <p>
                {t('device.destroyQr')}
                <br />
                {t('device.changeQr')}
              </p>
              <br />
              <p>{t('device.printConfirm')}</p>
            </center>
            <div className={'btn-wrap'}>
              <button
                type={'button'}
                className={'orange_white_btn'}
                onClick={onClick}
              >
                {t('button.confirm')}
              </button>
              <button
                type={'button'}
                className={'gray_white_btn'}
                onClick={onClose}
              >
                {t('button.close')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </ReactModal>
  );
}
